import React from "react";
import ColculationHero from "../sections/ColculationHero";
import ColculationSection from "../sections/ColculationSection";
import Brands from "../sections/Brands";
import ContactSection from "../sections/ContactSection";

const Colculation = () => {
  return (
    <div>
      <ColculationHero />
      <ColculationSection />
      <Brands />
      <ContactSection/>
    </div>
  );
};

export default Colculation;
